module.exports = __webpack_public_path__ + "img/20201216_155336.9974023c.jpg";